var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeStyles } from '@material-ui/core/styles';
var inputHeight = 40;
var inputBorder = '1px solid rgba(60, 60, 67, 0.29)';
var inputPadding = 11;
export default makeStyles(function (theme) {
    var baseStyles = {
        backgroundColor: theme.palette.background.default,
        boxShadow: 'none',
        border: inputBorder,
        borderRadius: 8,
        lineHeight: inputHeight + "px",
        '& .contenteditable': {
            outline: '0px solid transparent',
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: inputPadding,
            paddingRight: inputPadding,
            width: '100%',
            height: '100%',
        },
    };
    return {
        inputWrapper: __assign(__assign({}, baseStyles), { position: 'relative', minHeight: inputHeight + "px", whiteSpace: 'normal', overflow: 'hidden', '& [contenteditable]:not(:empty) + [contenteditable="false"]': {
                zIndex: -1,
            } }),
        textareaWrapper: __assign(__assign({}, baseStyles), { position: 'relative', height: 200, overflowX: 'hidden', overflowY: 'auto', '& [contenteditable]:not(:empty) + [contenteditable="false"]': {
                zIndex: -1,
            } }),
        errorBorder: {
            border: "1px " + theme.palette.error.main + " solid",
        },
        error: {
            fontSize: theme.typography.pxToRem(13),
        },
        disabled: {
            color: theme.palette.text.disabled,
        },
        chip: {
            color: '#303036',
            backgroundColor: '#C6C6C9',
            height: '24px',
        },
        placeholder: {
            position: 'absolute',
            top: 0,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: inputPadding,
            paddingRight: inputPadding,
            color: 'rgba(60, 60, 67, 0.3)',
            fontSize: theme.typography.pxToRem(16),
        },
    };
});
